export enum ComparatorEnum {
  EXACT,
  CONTAINS,
  STARTS_WITH,
}
